import {
  __esm,
  __export
} from "./chunk-PLDDJCW6.js";

// ../../node_modules/@mui/utils/formatMuiErrorMessage/formatMuiErrorMessage.js
function formatMuiErrorMessage(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}
var init_formatMuiErrorMessage = __esm({
  "../../node_modules/@mui/utils/formatMuiErrorMessage/formatMuiErrorMessage.js"() {
    "use strict";
  }
});

// ../../node_modules/@mui/utils/formatMuiErrorMessage/index.js
var formatMuiErrorMessage_exports = {};
__export(formatMuiErrorMessage_exports, {
  default: () => formatMuiErrorMessage
});
var init_formatMuiErrorMessage2 = __esm({
  "../../node_modules/@mui/utils/formatMuiErrorMessage/index.js"() {
    "use strict";
    init_formatMuiErrorMessage();
  }
});

// ../../node_modules/@mui/utils/clamp/clamp.js
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
var clamp_default;
var init_clamp = __esm({
  "../../node_modules/@mui/utils/clamp/clamp.js"() {
    "use strict";
    clamp_default = clamp;
  }
});

// ../../node_modules/@mui/utils/clamp/index.js
var clamp_exports = {};
__export(clamp_exports, {
  default: () => clamp_default
});
var init_clamp2 = __esm({
  "../../node_modules/@mui/utils/clamp/index.js"() {
    "use strict";
    init_clamp();
  }
});

export {
  formatMuiErrorMessage_exports,
  init_formatMuiErrorMessage2 as init_formatMuiErrorMessage,
  clamp_exports,
  init_clamp2 as init_clamp
};
//# sourceMappingURL=chunk-QR3JAPKL.js.map